export default __webpack_public_path__ + "static/media/node.574d841d.png";